<script setup lang="ts">
import { Primitive, type PrimitiveProps } from 'reka-ui'
import type { HTMLAttributes } from 'vue'
import { cn } from '../../../lib/utils'
import { type ButtonVariants, buttonVariants } from '.'

export interface ButtonProps extends PrimitiveProps {
  variant?: ButtonVariants['variant']
  size?: ButtonVariants['size']
  class?: HTMLAttributes['class']
  disabled?: boolean
  dataTestid?: string
}

const props = withDefaults(defineProps<ButtonProps>(), {
  as: 'button',
  size: 'sm'
})
</script>

<template>
  <Primitive
    data-slot="button"
    :as="as"
    :as-child="asChild"
    :class="cn(buttonVariants({ variant, size }), props.class)"
    :disabled
    :data-testid="props.dataTestid"
  >
    <slot />
  </Primitive>
</template>
